import Image from "next/image";
import React from 'react'
import styles from "./tnpsc-workshop.module.css";
import Banner from "../../assets/images/Tnpsc/IM-TOP-GR---IV-TEST-SERIES---Web-Banner.jpg";
import MobBanner from "../../assets/images/Tnpsc/IM-TOP-GR---IV-TEST-SERIES---Mobile-Banner.jpg";
import Navbar from '../../components/Navbar/Navbar';
import Footer from '../../components/Footer/Footer';
import Link from 'next/link';
import Head from 'next/head';

const Tnpsc_gr_IV_testbatch = () => {

const feestructure3 = [
  {
    center: "Anna Nagar",
    fee: {
      
      old: "All Student : ₹35,000",
    },
    batches: [
      {
        batch: "Batch I -  Offline Only",
        start: "27-08-2026",
        schedule:
          "https://www.shankariasacademy.com/pdf/TNPSC-2026/Tnpsc-MCP-Test-Serie-2027/Anna-nagar/Tnpsc-MCP-Test-Series-B1-AnnaNagar.pdf",
        admission:
          "https://admissionsv1.shankariasacademy.com/?center=ANNA_NAGAR&coursetype=TNPSC",
      },

      
    
    ],
  },

  

  
]



    return (
        <>

        <Head>
            <meta charset="UTF-8" />  
            <meta name="viewport" content="width=device-width, initial-scale=1" />
            <meta name="robots" content="noodp,noydir" />
            <meta name="robots" content="index,follow" />
            <meta name="robots" content="index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1" />
            <meta property="article:publisher" content="https://www.facebook.com/shankariasacademy" />
            <meta property="article:modified_time" content="2024-01-25T05:43:44+00:00" />
            <title>TNPSC Workshop Based Mains Cum Prelims Test Series 2027 | Shankar IAS Academy</title>
            <meta name="title" content="TNPSC Workshop Based Mains Cum Prelims Test Series 2027 | Shankar IAS Academy" />
            <meta name="description" content="Join the TNPSC Workshop Based Mains Cum Prelims Test Series 2027 at Shankar IAS Academy. Expert mentoring, structured classes, tests, evaluation, and complete exam preparation." />
            <meta name="keywords" content="TNPSC Workshop Based Mains Cum Prelims Test Series,TNPSC Test Series 2027,TNPSC Mains Test Series,TNPSC Prelims Test Series,TNPSC Coaching,TNPSC Classes,TNPSC Mock Test,TNPSC Exam Preparation,Shankar IAS Academy TNPSC,TNPSC Workshop Programme"></meta>
            <link rel="canonical" href="https://www.shankariasacademy.com/tnpsc-workshop-based-mains-prelims-test-series/ " />
            <meta property="og:locale" content="en_US" />
            <meta property="og:type" content="article" />
            <meta property="og:title" content="TNPSC Workshop Based Mains Cum Prelims Test Series 2027 | Shankar IAS Academy" />
            <meta property="og:description" content="Join the TNPSC Workshop Based Mains Cum Prelims Test Series 2027 at Shankar IAS Academy. Expert mentoring, structured classes, tests, evaluation, and complete exam preparation." />
            <meta property="og:url" content="https://www.shankariasacademy.com/tnpsc-workshop-based-mains-prelims-test-series/ " />
            <meta property="og:site_name" content="Shankar IAS Academy" />
            <meta name="twitter:card" content="summary_large_image" />
            <meta name="twitter:site" content="@shankarias" />
        </Head>

            <Navbar title="tnpsc" />

            <div className="container">
                <div className="pt-3 pt-md-4">
                    <h1 className={`${styles.pagemaintitle}`}>TNPSC Workshop Based Mains Cum Prelims Test Series 2027</h1>
                </div>
            </div>

       <div className="container pb-4">

            {/* <div className="row d-none d-md-block">
                <div className="col pt-3 pt-md-2">
                    <Image src={Banner} alt="tnpsc-group-i-prelims-test banner" title="TNPSC Group IV Prelims Test" className="img-fluid w-100"/>
                </div>
            </div>

            <div className="row d-block d-md-none">
                <div className="col pt-3 pt-md-5">
                    <Image src={MobBanner} alt="tnpsc-group-i-prelims-test banner" title="TNPSC Group IV Prelims Test" className="img-fluid w-100"/>
                </div>
            </div>  */}
       </div>

 {/* table */}

        <section className={styles.courseSection}>
           <div className="container">
                <div className={styles.headingBox}>
                    <h2> TNPSC  Mains Cum Prelims Test Series 2027</h2>
                 
                </div>

                <div className={`${styles.tableWrapper} d-none d-md-block`}>
                    <table className={styles.courseTable}>
                        <thead>
                           <tr>
                              <th>Center</th>
                              <th>Batch</th>
                              <th>Starts On</th>
                              <th>Fee</th>
                              <th>Schedule</th>
                              <th>Admission</th>
                            </tr>
                        </thead>

                        <tbody >
                                {feestructure3.map((centerItem) =>
                                    centerItem.batches.map((batch, index) => (
                                        <tr key={index}>

                                        {/* Center Common */}
                                        {index === 0 && (
                                            <td rowSpan={centerItem.batches.length}>
                                            {centerItem.center}
                                            </td>
                                        )}

                                        {/* Batch */}
                                        <td>{batch.batch}</td>

                                        {/* Start */}
                                        <td>{batch.start}</td>

                                        {/* Fee Separate */}
                                        <td>
                                            <div>{centerItem.fee.new}</div>
                                            <div>{centerItem.fee.old}</div>
                                        </td>
                                    

                                        {/* Schedule */}
                                        <td>
                                            {batch.schedule !== "#" ? (
                                            <a href={batch.schedule} target="_blank">
                                                <i className="bi bi-file-earmark-pdf-fill me-2"></i>
                                                View Pdf
                                            </a>
                                            ) : (
                                            <span>Update Soon</span>
                                            )}
                                        </td>

                                        {/* Admission */}
                                        <td>

                                            {batch.admission !== "#" ? (
                                            <a href={batch.admission} target="_blank">
                                              <button className={styles.payBtn}>
                                                Pay Now
                                              </button>
                                            </a>
                                            ) : (
                                            <span style={{color: "#002efc" }}>Admissions Closed</span>
                                            )}
                                        </td>

                                        </tr>
                                    ))
                                    )}
                        </tbody>
                    </table>
                </div>

                <div  className={`${styles.mobileView} d-block d-md-none`}>
                    {feestructure3.map((centerItem, centerIndex) =>
                      centerItem.batches.map((batch, index) => (
                        <div className={styles.card} key={index}>
                                        
                          <div className={styles.row}>
                             <span>Center</span>
                             <strong>{centerItem.center}</strong>
                          </div>

                          <div className={styles.row}>
                             {/* <span>Batch</span> */}
                             <strong>{batch.batch}</strong>
                          </div>

                          <div className={styles.row}>
                              <span>Start Date</span>
                              <strong>{batch.start}</strong>
                          </div>

                          <div className={styles.row}>
                            <span>Fee</span>
                            <strong>{centerItem.fee.new}</strong>
                          </div>

                          <div className={styles.row}>
                            <span>Old Fee</span>
                            <small>{centerItem.fee.old}</small>
                          </div>

                          <div className={styles.actions}>
                            <span>Schedule</span>
                              {batch.schedule !== "#" ? (
                            <a href={batch.schedule} target="_blank">
                               View
                            </a>
                            ) : (
                              <span>Update Soon</span>
                            )}
                          </div>

                          <div className={styles.actions}>

                             <span>Schedule</span>
                              {batch.admission !== "#" ? (
                            <a href={batch.admission} target="_blank">
                              <button className={styles.payBtn}>
                               Pay Now
                               </button>
                            </a>
                            ) : (
                              <span style={{color: "#002efc" }}>Admissions Closed</span>
                            )}
                                           
                          </div>

                        </div>
                      ))
                    )}
                </div>
            </div>
        </section>	

            <Footer />
        </>
    )
}

export default Tnpsc_gr_IV_testbatch;